<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['accordions']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              required: true
            }),
            {
              component: 'h3',
              innerText: 'Elementy akordeonu'
            },
            new fields.Formset({
              modelPath: [this, 'form', 'accordions'],
              blankObject: { items: [] },
              items: this.form.accordions.map((item, i) => ({
                headerLabel: get(item, ['title']),
                fields: [
                  new fields.Input({
                    label: 'Tytuł',
                    modelPath: [this, 'form', 'accordions', i, 'title'],
                    required: true
                  }),
                  {
                    component: 'h3',
                    innerText: 'Elementy'
                  },
                  this.getJuryItemsFormset(this.form.accordions[i].items, i)
                ]
              }))
            })
          ]
        }
      ]
    }
  },
  methods: {
    getJuryItemsFormset(juryItems, accordionIndex) {
      return new fields.Formset({
        modelPath: [this, 'form', 'accordions', accordionIndex, 'items'],
        items: juryItems.map((item, itemIndex) => {
          return {
            headerLabel: get(item, ['name']),
            fields: [
              new fields.Input({
                label: 'Imię i nazwisko',
                required: true,
                modelPath: [
                  this,
                  'form',
                  'accordions',
                  accordionIndex,
                  'items',
                  itemIndex,
                  'name'
                ]
              }),
              new fields.Input({
                label: 'Firma',
                modelPath: [
                  this,
                  'form',
                  'accordions',
                  accordionIndex,
                  'items',
                  itemIndex,
                  'company'
                ]
              }),
              new fields.Input({
                label: 'Stanowisko',
                modelPath: [
                  this,
                  'form',
                  'accordions',
                  accordionIndex,
                  'items',
                  itemIndex,
                  'position'
                ]
              }),
              new fields.Image({
                label: 'Zdjęcie',
                modelPath: [
                  this,
                  'form',
                  'accordions',
                  accordionIndex,
                  'items',
                  itemIndex,
                  'image'
                ]
              }),
              new fields.Input({
                label: 'Nagłówek',
                modelPath: [
                  this,
                  'form',
                  'accordions',
                  accordionIndex,
                  'items',
                  itemIndex,
                  'header'
                ]
              }),
            ]
          }
        })
      })
    }
  }
}
</script>
